import { Quantity } from "@/model/Quantity";

export class ModifiedQuantity{
    cug: string;
    quantity: Quantity;
}